import { cn } from "@/lib/utils";
import { NavLink } from "react-router-dom";

export const NavLinkDesktop = ({
  to,
  children,
  currentRoute,
  disableHover,
  isInMoreDropdown = false,
  onClick,
}: {
  to: string;
  children: React.ReactNode;
  currentRoute: string;
  disableHover?: boolean;
  isInMoreDropdown?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}) => {
  const isActive = currentRoute === to;

  return (
    <>
      <NavLink
        to={to}
        className={cn(
          "text-sm font-medium px-2 py-1.5 flex justify-start items-center gap-x-1 select-none whitespace-nowrap relative text-left",
          isActive ? "text-white" : "text-dark-tertiary",
          !disableHover && "hover:bg-panel-foreground hover:text-white",
          !isInMoreDropdown && "rounded",
        )}
        onClick={onClick}
      >
        {children}
      </NavLink>
    </>
  );
};
